// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"df4f21b0","182":"7b22ba1c","475":"e4960901","632":"317d3eeb","771":"297bbe4a","824":"4f7272b3","960":"3c4d650f"}[chunkId] + ".chunk.css";
};